const ErrorLabel = ({errorTitle , block = false})=>{
let classes = 'warning-';
classes+= block?'block':'inline';
return errorTitle != null || undefined ?<span className={classes}>{errorTitle}</span>:'';
}
export default ErrorLabel;